// plop_marker:layouts_import
import PlainBanner from "./plain-banner/index.js";
import WithBackgroundBanner from "./with-background-banner/index.js";
export default {
    // plop_marker:layouts_add_layout
    PlainBanner,
    WithBackgroundBanner
};
